<template>
    <div :class="{ 'panelCard': !isMapChartType }">
        <template v-if="isLoading">
            <ChartPreloader :classes="isMapChartType ? 'mapPreloader panelCard' : ''" />
        </template>
        <MapChart
            v-if="isMapChartType"
            :chart-title="chartTitle"
            :loading="isLoading"
            @set-category="$emit('set-category', $event)">
            <template #map>
                <div
                    ref="chartWrapper"
                    class="highlightChart__highChart--map">
                </div>
            </template>
        </MapChart>
        <div
            v-else
            class="highlightSection__chartBox">
            <div
                class=" highlightChart__wrapper"
                :class="{ 'opacity-0' : !chart }">
                <div class="padding-all-10">
                    <h5 class="highlightChart__title hl-module text-color--dark-blue-gray">
                        {{ chartTitle }}
                    </h5>
                    <div
                        ref="chartWrapper"
                        class="highlightChart__highChart">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MapChart from 'outlook/components/marketHighlights/mapChart';

    const CHART_TYPE_MAP = 'map';

    export default {
        components: {
            MapChart,
            ChartPreloader: () => import('outlook/components/marketHighlights/chartPreloader'),
        },
        props: {
            chartTitle: { type: String, required: true },
            chartType: { type: String, required: true },
            chart: { type: Object, default: () => null },
        },
        computed: {
            isMapChartType() {
                return this.chartType === CHART_TYPE_MAP;
            },
            isLoading() {
                return this.chart === null;
            },
        },
        watch: {
            chart() {
                if (this.chart) {
                    this.renderChart(this.chart);
                }
            },
        },
        methods: {
            renderChart() {
                /* eslint-disable no-undef */
                if (this.isMapChartType && this.chart) {
                    const mapChartData = this.chart;
                    // Disable legend gradient
                    mapChartData.legend = { enabled: false };
                    mapChartData.series[0].mapData = Highcharts.maps['custom/world'];
                    this.$nextTick(() => {
                        new Highcharts.Map(this.$refs.chartWrapper, mapChartData);
                    });
                } else {
                    this.$nextTick(() => {
                        new Highcharts.Chart(this.$refs.chartWrapper, this.chart);
                    });
                }
                /* eslint-enable */
            },
        },
    };
</script>
